var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboCaratRightSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4227 13.245L9.39841 8.26929C9.55294 8.11476 9.55294 7.87525 9.39841 7.72072L4.4227 2.75273C4.35316 2.68319 4.3068 2.58275 4.3068 2.48231L4.3068 1.38518C4.3068 1.0375 4.72402 0.867519 4.96354 1.11476L11.5772 7.72845C11.7317 7.88297 11.7317 8.12249 11.5772 8.27701L4.96354 14.8907C4.72402 15.1302 4.3068 14.9602 4.3068 14.6203L4.3068 13.5309C4.3068 13.4304 4.34543 13.33 4.4227 13.2605L4.4227 13.245Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboCaratRightSmall);
export default __webpack_public_path__ + "static/media/FBOCaratRightSmall.921832c6c07458c50db145164c8bf8b0.svg";
export { ForwardRef as ReactComponent };